export function isWindows() {
  return (window.navigator.platform || '').startsWith('Win')
}
